import { render } from "./Original.vue?vue&type=template&id=4cbb6b8c&scoped=true&ts=true"
import script from "./Original.vue?vue&type=script&lang=ts"
export * from "./Original.vue?vue&type=script&lang=ts"

import "./Original.vue?vue&type=style&index=0&id=4cbb6b8c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbb6b8c"]])

export default __exports__